'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var config = function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _ActionTypes.INITIALIZE_CONFIG:
      return action.config;
    default:
      return state;
  }
};

exports.default = config;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Config.js
// module id = 383
// module chunks = 3 4 5